import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [1.75347045673],
    [0.03341656453, 4.66925680415, 6283.0758499914],
    [0.00034894275, 4.62610242189, 12566.1516999828],
    [0.00003497056, 2.74411783405, 5753.3848848968],
    [0.00003417572, 2.82886579754, 3.523118349],
    [0.00003135899, 3.62767041756, 77713.7714681205],
    [0.00002676218, 4.41808345438, 7860.4193924392],
    [0.00002342691, 6.13516214446, 3930.2096962196],
    [0.00001324294, 0.74246341673, 11506.7697697936],
    [0.00001273165, 2.03709657878, 529.6909650946],
    [0.00001199167, 1.10962946234, 1577.3435424478],
    [0.0000099025, 5.23268072088, 5884.9268465832],
    [0.00000901854, 2.04505446477, 26.2983197998],
    [0.00000857223, 3.50849152283, 398.1490034082],
    [0.00000779786, 1.17882681962, 5223.6939198022],
    [0.00000753141, 2.53339052847, 5507.5532386674],
    [0.00000505267, 4.58292599973, 18849.2275499742],
    [0.00000492392, 4.20505711826, 775.522611324],
    [0.00000356672, 2.91954114478, 0.0673103028],
    [0.00000317087, 5.84901948512, 11790.6290886588],
    [0.00000284125, 1.89869240932, 796.2980068164],
    [0.00000271112, 0.31486255375, 10977.078804699],
    [0.00000242879, 0.34481445893, 5486.777843175],
    [0.00000206217, 4.80646631478, 2544.3144198834],
    [0.00000205478, 1.86953770281, 5573.1428014331],
    [0.00000202318, 2.45767790232, 6069.7767545534],
    [0.00000155516, 0.83306084617, 213.299095438],
    [0.00000132212, 3.41118292683, 2942.4634232916],
    [0.00000126225, 1.08295459501, 20.7753954924],
    [0.00000115132, 0.64544911683, 0.9803210682],
    [0.00000102851, 0.63599845579, 4694.0029547076],
    [0.00000101895, 0.97569280312, 15720.8387848784],
    [0.00000101724, 4.2667980198, 7.1135470008],
    [0.00000099206, 6.20992926918, 2146.1654164752],
    [0.00000097607, 0.68101342359, 155.4203994342],
    [0.00000085803, 5.9832263126, 161000.6857376741],
    [0.00000085128, 1.29870764804, 6275.9623029906],
    [0.00000084711, 3.67080093031, 71430.69561812909],
    [0.00000079637, 1.80791287082, 17260.1546546904],
    [0.00000078757, 3.03697458703, 12036.4607348882],
    [0.00000074651, 1.755089133, 5088.6288397668],
    [0.00000073874, 3.50319414955, 3154.6870848956],
    [0.00000073547, 4.67926633877, 801.8209311238],
    [0.00000069627, 0.83297621398, 9437.762934887],
    [0.00000062449, 3.97763912806, 8827.3902698748],
    [0.00000061148, 1.81839892984, 7084.8967811152],
    [0.00000056963, 2.78430458592, 6286.5989683404],
    [0.00000056116, 4.38694865354, 14143.4952424306],
    [0.00000055577, 3.47006059924, 6279.5527316424],
    [0.00000051992, 0.18914947184, 12139.5535091068],
    [0.00000051605, 1.33282739866, 1748.016413067],
    [0.00000051145, 0.28306832879, 5856.4776591154],
    [0.00000049, 0.48735014197, 1194.4470102246],
    [0.00000041036, 5.36817592855, 8429.2412664666],
    [0.00000040938, 2.39850938714, 19651.048481098],
    [0.000000392, 6.16833020996, 10447.3878396044],
    [0.0000003677, 6.04133863162, 10213.285546211],
    [0.00000036596, 2.56957481827, 1059.3819301892],
    [0.00000035954, 1.70875808777, 2352.8661537718],
    [0.0000003557, 1.775968892, 6812.766815086],
    [0.00000033296, 0.59310278598, 17789.845619785],
    [0.00000030412, 0.44294464169, 83996.84731811189],
    [0.00000030047, 2.73975124088, 1349.8674096588],
    [0.00000025352, 3.16470891653, 4690.4798363586],
];

const VSOP87_L1: Vsop87Element = [
    [6283.0758499914],
    [0.00206058863, 2.67823455808, 6283.0758499914],
    [0.00004303419, 2.63512233481, 12566.1516999828],
    [0.00000425264, 1.59046982018, 3.523118349],
    [0.00000119305, 5.79555765566, 26.2983197998],
    [0.00000109017, 2.96631010675, 1577.3435424478],
    [0.00000093479, 2.59211109542, 18849.2275499742],
    [0.00000072121, 1.13840581212, 529.6909650946],
    [0.00000067784, 1.87453300345, 398.1490034082],
    [0.0000006735, 4.40932832004, 5507.5532386674],
    [0.00000059045, 2.88815790631, 5223.6939198022],
    [0.00000055976, 2.17471740035, 155.4203994342],
    [0.00000045411, 0.39799502896, 796.2980068164],
    [0.00000036298, 0.46875437227, 775.522611324],
    [0.00000028962, 2.64732254645, 7.1135470008],
    [0.00000020844, 5.34138275149, 0.9803210682],
    [0.00000019097, 1.84628376049, 5486.777843175],
    [0.00000018508, 4.96855179468, 213.299095438],
    [0.00000017293, 2.9911676063, 6275.9623029906],
    [0.00000016233, 0.03216587315, 2544.3144198834],
    [0.00000015832, 1.43049301283, 2146.1654164752],
    [0.00000014608, 1.2046979369, 10977.078804699],
    [0.00000012461, 2.83432282119, 1748.016413067],
    [0.00000011877, 3.25805082007, 5088.6288397668],
    [0.00000011808, 5.27379760438, 1194.4470102246],
    [0.00000011514, 2.07502080082, 4694.0029547076],
    [0.00000010641, 0.76614722966, 553.5694028424],
    [0.00000009969, 1.30263423409, 6286.5989683404],
    [0.00000009721, 4.2392586526, 1349.8674096588],
    [0.00000009452, 2.69956827011, 242.728603974],
    [0.00000008577, 5.6447608598, 951.7184062506],
    [0.00000007576, 5.30056172859, 2352.8661537718],
    [0.00000006385, 2.65034514038, 9437.762934887],
    [0.00000006101, 4.66633726278, 4690.4798363586],
];

const VSOP87_L2: Vsop87Element = [
    [0.00008721859, 1.07253635559, 6283.0758499914],
    [0.00000294833, 0.43717350256, 12566.1516999828],
    [0.00000027338, 0.05295636147, 3.523118349],
    [0.00000016333, 5.18820215724, 26.2983197998],
    [0.00000015745, 3.68504712183, 155.4203994342],
    [0.00000009425, 0.29667114694, 18849.2275499742],
    [0.00000008938, 2.05706319592, 77713.7714681205],
    [0.0000000694, 0.82691541038, 775.522611324],
    [0.00000005061, 4.6624323168, 1577.3435424478],
    [0.0000000406, 1.03067032318, 7.1135470008],
    [0.00000003809, 3.44043369494, 5573.1428014331],
    [0.00000003464, 5.14021224609, 796.2980068164],
    [0.00000003172, 6.05479318507, 5507.5532386674],
    [0.0000000302, 1.19240008524, 242.728603974],
    [0.00000002885, 6.11705865396, 529.6909650946],
    [0.00000002719, 0.30363248164, 398.1490034082],
    [0.00000002538, 2.27966434314, 553.5694028424],
    [0.00000002365, 4.37666117992, 5223.6939198022],
    [0.00000002078, 3.75435095487, 0.9803210682],
    [0.00000001675, 0.90149951436, 951.7184062506],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000289058, 5.84173149732, 6283.0758499914],
    [0.00000020712, 6.0498393902, 12566.1516999828],
    [0.00000002962, 5.1956057957, 155.4203994342],
    [0.00000001288, 4.7219761197, 3.523118349],
    [0.00000000635, 5.96904899168, 242.728603974],
    [0.0000000057, 5.54182903238, 18849.2275499742],
    [0.00000000402, 3.78606612895, 553.5694028424],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000007714, 4.14117321449, 6283.0758499914],
    [0.00000001016, 3.27573644241, 12566.1516999828],
    [0.0000000042, 0.41892851415, 155.4203994342],
];

const VSOP87_L5: Vsop87Element = [[0.00000000172, 2.74854172392, 6283.0758499914]];

const VSOP87_B0: Vsop87Element = [
    [0.0000027962, 3.19870156017, 84334.66158130829],
    [0.00000101643, 5.42248619256, 5507.5532386674],
    [0.00000080445, 3.88013204458, 5223.6939198022],
    [0.00000043806, 3.70444689759, 2352.8661537718],
    [0.00000031933, 4.00026369781, 1577.3435424478],
];

const VSOP87_B1: Vsop87Element = [
    [0.00227777722, 3.4137662053, 6283.0758499914],
    [0.00003805678, 3.37063423795, 12566.1516999828],
];

const VSOP87_B2: Vsop87Element = [];

const VSOP87_B3: Vsop87Element = [];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [1.00013988784],
    [0.01670699632, 3.09846350258, 6283.0758499914],
    [0.00013956024, 3.05524609456, 12566.1516999828],
    [0.0000308372, 5.19846674381, 77713.7714681205],
    [0.00001628463, 1.17387558054, 5753.3848848968],
    [0.00001575572, 2.84685214877, 7860.4193924392],
    [0.00000924799, 5.45292236722, 11506.7697697936],
    [0.00000542439, 4.56409151453, 3930.2096962196],
    [0.0000047211, 3.66100022149, 5884.9268465832],
    [0.00000345969, 0.96368627272, 5507.5532386674],
    [0.0000032878, 5.89983686142, 5223.6939198022],
    [0.00000306784, 0.29867139512, 5573.1428014331],
    [0.00000243181, 4.2734953079, 11790.6290886588],
    [0.00000211836, 5.84714461348, 1577.3435424478],
    [0.0000018574, 5.02199710705, 10977.078804699],
    [0.00000174844, 3.01193636733, 18849.2275499742],
    [0.00000109835, 5.0551063586, 5486.777843175],
    [0.00000098316, 0.88681311278, 6069.7767545534],
    [0.000000865, 5.68956418946, 15720.8387848784],
    [0.00000085831, 1.27079125277, 161000.6857376741],
    [0.00000064908, 0.27251341435, 17260.1546546904],
    [0.00000062917, 0.92177053978, 529.6909650946],
    [0.00000057056, 2.01374292245, 83996.84731811189],
    [0.00000055736, 5.2415979917, 71430.69561812909],
    [0.00000049384, 3.24501240359, 2544.3144198834],
    [0.00000046966, 2.57799853213, 775.522611324],
    [0.00000044666, 5.53715663816, 9437.762934887],
    [0.0000004252, 6.01110257982, 6275.9623029906],
    [0.00000038963, 5.36063832897, 4694.0029547076],
    [0.00000038245, 2.39255343973, 8827.3902698748],
    [0.00000037486, 0.82961281844, 19651.048481098],
    [0.00000036957, 4.90107587287, 12139.5535091068],
    [0.00000035661, 1.67447135798, 12036.4607348882],
    [0.00000034537, 1.84270693281, 2942.4634232916],
    [0.00000033193, 0.24370221704, 7084.8967811152],
    [0.00000031922, 0.18368299942, 5088.6288397668],
    [0.00000031846, 1.77775642078, 398.1490034082],
    [0.00000028468, 1.21344887533, 6286.5989683404],
    [0.00000027795, 1.89934427832, 6279.5527316424],
    [0.00000026275, 4.58896863104, 10447.3878396044],
];

const VSOP87_R1: Vsop87Element = [
    [0.00103018607, 1.10748968172, 6283.0758499914],
    [0.00001721238, 1.06442300386, 12566.1516999828],
    [0.00000032345, 1.02168583254, 18849.2275499742],
    [0.00000030801, 2.84358443952, 5507.5532386674],
    [0.00000024978, 1.31906570344, 5223.6939198022],
    [0.00000018487, 1.42428709076, 1577.3435424478],
    [0.00000010077, 5.91385248388, 10977.078804699],
    [0.00000008654, 1.42046854427, 6275.9623029906],
    [0.00000008635, 0.27158192945, 5486.777843175],
    [0.00000005069, 1.68613408916, 5088.6288397668],
];

const VSOP87_R2: Vsop87Element = [
    [0.00004359385, 5.78455133808, 6283.0758499914],
    [0.00000123633, 5.57935427994, 12566.1516999828],
    [0.00000008792, 3.62777893099, 77713.7714681205],
    [0.00000005689, 1.86958905084, 5573.1428014331],
    [0.00000003302, 5.47034879713, 18849.2275499742],
    [0.00000001471, 4.47964125007, 5507.5532386674],
];

const VSOP87_R3: Vsop87Element = [
    [0.00000144595, 4.27319433901, 6283.0758499914],
    [0.00000006729, 3.91706261708, 12566.1516999828],
];

const VSOP87_R4: Vsop87Element = [[0.00000003858, 2.56389016346, 6283.0758499914]];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
